import React from "react";

function Info() {
    return (
        <div>
            <h2>AI-Generated Summary</h2>
            <p>Summary Generation Feature Coming Soon.</p>
        </div>
    );
}

export default Info;
